//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ProjectTeamClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type RequestAccessProjectTeamQueryParameters = {
  projectId: number ;
}

export function getAvailableTeamMembersUrl(): string {
  let url_ = getBaseUrl() + "/api/project-team";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAvailableTeamMembersDefaultOptions: Omit<UseQueryOptions<Types.SearchTeamMemberResultDto[], unknown, Types.SearchTeamMemberResultDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SearchTeamMemberResultDto[], unknown, Types.SearchTeamMemberResultDto[]>, 'queryFn'>> = {
};
export function getGetAvailableTeamMembersDefaultOptions() {
  return getAvailableTeamMembersDefaultOptions;
};
export function setGetAvailableTeamMembersDefaultOptions(options: typeof getAvailableTeamMembersDefaultOptions) {
  getAvailableTeamMembersDefaultOptions = options;
}

export function getAvailableTeamMembersQueryKey(): QueryKey;
export function getAvailableTeamMembersQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'ProjectTeamClient',
      'getAvailableTeamMembers',
    ]);
}
export function __getAvailableTeamMembers(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getAvailableTeamMembers(
axiosConfig    );
}

export function useGetAvailableTeamMembersQuery<TSelectData = Types.SearchTeamMemberResultDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.SearchTeamMemberResultDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAvailableTeamMembersQuery<TSelectData = Types.SearchTeamMemberResultDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SearchTeamMemberResultDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SearchTeamMemberResultDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getAvailableTeamMembers(context, axiosConfig) : __getAvailableTeamMembers,
    queryKey: getAvailableTeamMembersQueryKey(),
    ...getAvailableTeamMembersDefaultOptions as unknown as Omit<UseQueryOptions<Types.SearchTeamMemberResultDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetAvailableTeamMembersData(queryClient: QueryClient, updater: (data: Types.SearchTeamMemberResultDto[] | undefined) => Types.SearchTeamMemberResultDto[], ) {
  queryClient.setQueryData(getAvailableTeamMembersQueryKey(),
    updater
  );
}

export function setGetAvailableTeamMembersDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SearchTeamMemberResultDto[] | undefined) => Types.SearchTeamMemberResultDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function requestAccessUrl(projectId: number): string {
  let url_ = getBaseUrl() + "/api/project-team/{projectId}/request-access";
if (projectId === undefined || projectId === null)
  throw new Error("The parameter 'projectId' must be defined.");
url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function requestAccessMutationKey(projectId: number): MutationKey {
  return trimArrayEnd([
      'ProjectTeamClient',
      'requestAccess',
      projectId as any,
    ]);
}

export function useRequestAccessMutation<TContext>(projectId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = requestAccessMutationKey(projectId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.requestAccess(projectId),
    mutationKey: key,
  });
}
  
type RequestAccess__MutationParameters = RequestAccessProjectTeamQueryParameters

export function useRequestAccessMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RequestAccess__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RequestAccessProjectTeamQueryParameters}): UseMutationResult<void, unknown, RequestAccess__MutationParameters, TContext> {
  const key = requestAccessMutationKey(options?.parameters?.projectId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RequestAccess__MutationParameters) => Client.requestAccess(data.projectId ?? options?.parameters?.projectId!),
  mutationKey: key,
});
}